import { ROLES } from 'src/infra/Api/CHL/roles.chile'

export const getChileRoles = () => {
  return ROLES
}
